// client/src/pages/Founder.js
import React from "react";
import founderImg from "../assets/1809042.jpg";

export default function Founder() {
  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-900 text-slate-900 dark:text-white px-6 py-12">
      <div className="max-w-5xl mx-auto">

        {/* HEADER */}
        <div className="text-center mb-14">
          <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight text-indigo-600 dark:text-indigo-400">
            Meet the Founder
          </h1>
          <p className="text-slate-500 dark:text-slate-400 mt-3 text-lg">
            Vision • Innovation • Leadership
          </p>
        </div>

        {/* FOUNDER HERO CARD */}
        <div className="bg-white dark:bg-slate-800 shadow-xl rounded-2xl p-8 flex flex-col md:flex-row items-center gap-10">

          {/* IMAGE */}
          <div className="relative">
            <img
              src={founderImg}
              alt="Founder"
              className="w-44 h-44 md:w-56 md:h-56 object-cover rounded-full shadow-lg ring-4 ring-indigo-600/30"
            />
            <div className="absolute inset-0 rounded-full blur-xl bg-indigo-600/20 -z-10"></div>
          </div>

          {/* MAIN TEXT */}
          <div className="flex-1">

            <h2 className="text-3xl font-bold text-indigo-600 dark:text-indigo-400">
              Harsh Vardhan
            </h2>

            <p className="text-slate-600 dark:text-slate-300 mt-2 italic">
              Founder • CEO • Visionary behind CollegePal
            </p>

            <p className="mt-4 text-slate-700 dark:text-slate-200 leading-relaxed text-justify">
            Harsh Vardhan is a B.Tech CSE student, innovator, and builder who is focused on creating practical systems that help students collaborate, learn, and grow together.
              <span className="font-semibold text-indigo-600 dark:text-indigo-400">
                {" "}
              </span>
              <br /><br />
              Inspired by brilliant minds and entrepreneurs,
              Harsh believes in transforming ideas into powerful products.
              CollegePal is his vision of a student ecosystem where skills,
              talent, and opportunity merge.
            </p>

          </div>
        </div>

        {/* VISION + MISSION */}
        <div className="mt-14 grid md:grid-cols-2 gap-10">

          {/* Vision */}
          <div className="bg-white dark:bg-slate-800 p-8 rounded-2xl shadow-lg">
            <h3 className="text-2xl font-bold text-indigo-600 dark:text-indigo-400 mb-2">
              🌍 Vision
            </h3>
            <p className="text-slate-700 dark:text-slate-300 leading-relaxed">
              To build the largest student-powered ecosystem where collaboration replaces competition,
              talent meets opportunity, and innovation begins early.
            </p>
          </div>

          {/* Mission */}
          <div className="bg-white dark:bg-slate-800 p-8 rounded-2xl shadow-lg">
            <h3 className="text-2xl font-bold text-indigo-600 dark:text-indigo-400 mb-2">
              🚀 Mission
            </h3>
            <ul className="text-slate-700 dark:text-slate-300 leading-relaxed space-y-2 list-disc ml-5">
              <li>Empower students to earn through their skills.</li>
              <li>Provide a platform for confidence and real-world experience.</li>
              <li>Create opportunities for collaboration and innovation.</li>
              <li>Make college life smarter, easier, and more connected.</li>
            </ul>
          </div>
        </div>

        {/* FOUNDER MESSAGE */}
        <div className="mt-16 bg-gradient-to-r from-indigo-600 to-indigo-500 dark:from-indigo-500 dark:to-indigo-400 text-white rounded-2xl p-10 shadow-xl">
          <h3 className="text-3xl font-bold mb-3 text-center">
            A Word from the Founder
          </h3>
          <p className="text-lg italic text-center leading-relaxed max-w-3xl mx-auto">
            “Every revolutionary idea begins as a spark.  
            CollegePal was born from the belief that students deserve a platform that trusts them,
            empowers them, and elevates them.  
            This is just the beginning — and you’re part of the journey.”
          </p>
          <p className="mt-4 text-center font-semibold">– Harsh Vardhan</p>
        </div>

        {/* FOOTER */}
        <div className="text-center text-slate-500 dark:text-slate-400 text-sm mt-16">
          © {new Date().getFullYear()} CollegePal • Founded by Harsh Vardhan
        </div>

      </div>
    </div>
  );
}
